module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.visible) ? _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-bg",
    on: {
      "click": _vm.hide
    }
  }), _c('div', {
    staticClass: "modal"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_c('span', {
    staticClass: "btn-close"
  }, [_vm._v("X")])]), _vm._t("default")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6c47788"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 377
// module chunks = 1